import { Base } from 'active-resource';
import { InterviewResource } from 'util/resources/Interview';
import { JobApplicationAttributes } from 'util/resources/JobApplication';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';

/**
 * Relationship classes
 */
export class UserProfileMetadataAttributes {
  id: string = null;
  conversation?: {
    lastEmployerMessage?: {
      createdAt?: string;
      employerProfileFirstName?: string;
      employerProfileId?: string;
      data?: string;
    };
    lastUserProfileMessage?: {
      createdAt?: string;
      readAt?: string;
      data?: string;
      profileType?: string;
      profileId?: string;
    };
    lastInterviewMessage?: {
      createdAt: string;
      employerProfileFirstName: string;
      employerProfileId: string;
      employerProfileLastName: string;
      profileId: string;
      profileType: string;
      readAt: string;
      metadata: {
        invitationName: string;
        invitationPath: string;
      };
    };
  } = null;
  jobApplication?: JobApplicationAttributes = new JobApplicationAttributes();
  notes: {
    count: number;
  };
}

export class UserProfileMetadataBelongsTo {}

export class UserProfileMetadataHasOne {
  interview: () => InterviewResource = () => new InterviewResource();
}

export class UserProfileMetadataHasMany {}

/**
 * Utility interfaces
 */
export interface UserProfileMetadataMethods {}

export interface UserProfileMetadataInterface
  extends UserProfileMetadataAttributes,
    UserProfileMetadataHasOne,
    UserProfileMetadataType {}

type UserProfileMetadataType = GConstructor<UserProfileMetadataInterface>;

export interface UserProfileMetadataResource
  extends Base<UserProfileMetadataAttributes>,
    UserProfileMetadataInterface,
    UserProfileMetadataMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<UserProfileMetadataAttributes>({
    queryName: 'employers/user_profiles_metadata',
    className: 'UserProfileMetadatum',
    AttributesClass: UserProfileMetadataAttributes,
    HasOneClasses: [
      {
        Klass: UserProfileMetadataHasOne,
      },
    ],
  });

export const UserProfileMetadataResourceClass = <TBase extends UserProfileMetadataType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements UserProfileMetadataMethods {};

export class UserProfileMetadataResource extends ClassExtender<UserProfileMetadataInterface>(
  BaseClass,
  UserProfileMetadataResourceClass,
) {}

/**
 * Resource instance
 */
export const UserProfileMetadata = APILibrary.createResource<UserProfileMetadataResource>(
  UserProfileMetadataResource,
);
